import React from "react";

const ConfirmBox = (props) => {
  const { isOpen, func, close, msg, title } = props;
  var displaystyle = isOpen ? { display: "block" } : { display: "none" };
  var _class = isOpen ? "show" : "";
  //var _inputForm = inputForm.isOpen ? inputForm.result : null;

  return isOpen ? (
    <div
      className={"modal in " + _class}
      id="MsgModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="MsgModalCenterTitle"
      aria-hidden="true"
      style={({ opacity: "1" }, displaystyle)}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="MsgModalLongTitle">
              {" "}
              {title}
              {/* Betriebsanleitung neu generieren */}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                close();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {msg}
            {/* <p>Möchten Sie die Betriebsanleitung <strong>mit Abnahmeprotokoll</strong> generieren?</p> */}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                close();
              }}
            >
              Abbrechen
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                func(false);
              }}
            >
              NEIN
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                func(true);
              }}
            >
              JA
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
export default ConfirmBox;
